import React, {FC, useContext, useEffect, useState} from 'react'
import {Avatar, Button, Divider, Dropdown, Flex, Menu, MenuProps, Space, Tooltip} from "antd";
import {SideSearch} from "../../styled";
import {GoSearch} from "react-icons/go";
import {FaPlus, FaRegFolderClosed} from "react-icons/fa6";
import {Text} from "../../../../theme/typography";
import {COLORS, TYPOGRAPHY_SIZES} from "../../../../theme/constants";
import {FiUser} from "react-icons/fi";
import {IoChevronDownOutline, IoLogOutOutline, IoSettingsOutline} from "react-icons/io5";
import {useNavigate} from "react-router-dom";
import {defaultUser, ProjectContext, UserContext} from "../../../../services/contexts";
import {getRole} from "../../../../services/utils";
import {Card, CustomMenu} from './styled'
import ProjectMenuItem from "../ProjectMenuItem/ProjectMenuItem";
import {IProject} from "../../../../models/project";

interface IProps {
    showModal: () => void
    projects: IProject[]
}

const FloatingSideCard: FC<IProps> = (props) => {
    const {showModal, projects} = props;
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1365);
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const {user, setUser} = useContext(UserContext);
    const {selectedProject, setSelectedProject} = useContext(ProjectContext);
    const [projectList, setProjectList] = useState<IProject[]>([]);
    // const [selectedMenuKey, setSelectedMenuKey] = useState(selectedProject?.id);

    useEffect(() => {
        setProjectList(projects);
        // setSelectedMenuKey(selectedProject?.id)
    }, [projects]);


    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1365);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    const onFilterProjects = (filter: string) => {
        if (filter != '') {
            const filteredProjects = projectList.filter((project) => project.name.toLowerCase().includes(filter.toLowerCase()));
            setProjectList(filteredProjects);
        } else setProjectList(projects);

    }


    const handleLogout = () => {
        localStorage.removeItem("AccessToken");
        localStorage.removeItem("isAuthenticated");
        localStorage.removeItem("user");
        setUser(defaultUser);
        navigate("/login");
    };


    const items: MenuProps["items"] = [
        {
            key: "1",
            label: <Text size={TYPOGRAPHY_SIZES.SMALL}>My Profile</Text>,
            icon: <FiUser size={16} color={COLORS.colorText}/>,
            onClick: () => {
                navigate('/profile')
            }
        },
        {
            type: "divider",
        },
        {
            key: "3",
            label: (
                <Text size={TYPOGRAPHY_SIZES.SMALL} color={COLORS.colorError}>
                    Logout
                </Text>
            ),
            icon: <IoLogOutOutline size={16} color={COLORS.colorError}/>,
            onClick: handleLogout,
        },
    ];


    return <Card style={{height: '94vh'}}>
        <Flex vertical={true} justify={"space-between"} gap={"large"} style={{height: '100%'}}>
            <div style={{height: 'calc(100% - 60px)', overflowY: 'auto'}}>
                <div style={{color: "#FFF", marginTop: 25}}></div>
                <Space align={"center"} style={{width: '100%', padding: '0 12px'}}>
                    {!isSmallScreen &&
                        <SideSearch placeholder={'Search projects'} prefix={<GoSearch/>} onChange={(e) => {
                            onFilterProjects(e.target.value)
                        }}/>}
                    <Tooltip title="Create a new project">
                        <Button type="text" shape="circle" icon={<FaPlus/>} onClick={showModal}/>
                    </Tooltip>
                </Space>

                <Divider/>

                <CustomMenu
                    style={{border: 'None'}}
                    defaultSelectedKeys={["1"]}
                    selectedKeys={selectedProject?.id ? [selectedProject.id] : []}
                    items={
                        projectList ? [...projectList]  // Create a shallow copy
                            .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
                            .map((p) => ({
                                key: p.id,
                                icon: <FaRegFolderClosed/>,
                                label: <ProjectMenuItem project={p}/>,
                                onClick: () => {
                                    setSelectedProject(p);
                                }
                            })) : []
                    }
                />
            </div>

            <Dropdown
                menu={{items}}
                arrow
                placement="topRight"
                trigger={["click"]}
            >
                <Flex
                    vertical={false}
                    justify="space-between"
                    align={"center"}
                    gap={14}
                    style={{cursor: "pointer"}}
                >
                    <Avatar style={{backgroundColor: COLORS.colorBgPrimary}} icon={<FiUser/>}
                            size={'large'}/>
                    {!isSmallScreen && (
                        <Flex vertical={true} justify={"center"} align={"center"}>
                            <Text weight={700}>{user.first_name} {user.last_name}</Text>
                            <Text size={TYPOGRAPHY_SIZES.SMALL}>{getRole(user)}</Text>
                        </Flex>
                    )}

                    <IoChevronDownOutline
                        color={COLORS.colorTextSecondary}
                        size={14}
                    />
                </Flex>
            </Dropdown>
        </Flex>


    </Card>
}

export default FloatingSideCard;